module.exports = __webpack_public_path__ + "img/introduce.916115d9.jpg";